import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import "./index.css";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { register } from "./serviceWorkerRegistration";
import "bootstrap/dist/css/bootstrap.css";
import "./App.scss";
import { BrowserRouter as Router } from "react-router-dom";
import config from "./settings/config";

Sentry.init({
  dsn: "https://592681d45cc94ef0b9022d2848895475@sentry.hamravesh.com/5143",
  integrations: [new Integrations.BrowserTracing()],
  environment: config.sentryEnvironment,
  tracesSampleRate: 0.2,
});

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
register();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
